import { Icon, Link, Text } from "@shopify/polaris";
import { CashDollarIcon, LinkIcon, StoreIcon } from "@shopify/polaris-icons";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const StoreDetails = () => {
  const [storeData, setStoreData] = useState({
    primaryDomain: "",
    currencyCode: "",
  });
  const location = useLocation();

  useEffect(() => {
    const shop = new URLSearchParams(location.search).get("shop");
    const fetchStoreData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/shopify/get_store_data?shop=${shop}`,
        );
        const data = await response.json();
        if (data.status && data.data.shop) {
          setStoreData({
            primaryDomain: data.data.shop.primaryDomain.url,
            currencyCode: data.data.shop.currencyCode,
          });
        }
      } catch (error) {
        console.error("Error fetching store data:", error);
      }
    };

    fetchStoreData();
  }, [location.search]);

  return (
    <div className="settings-card">
      <div className="settings-card__header">
        <span className="app-icon-tile app-icon-tile--blue">
          <Icon source={StoreIcon} tone="base" />
        </span>
        <div>
          <h3>Store Details</h3>
          <p>Domain and currency used for Google submissions.</p>
        </div>
      </div>

      <div className="settings-field">
        <div className="settings-field__label">
          <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            <Icon source={LinkIcon} tone="base" />
            Primary Domain
          </span>
        </div>
        <div className="settings-field__control">
          {storeData.primaryDomain ? (
            <Link url={storeData.primaryDomain}>{storeData.primaryDomain}</Link>
          ) : (
            <Text as="span" tone="subdued">
              —
            </Text>
          )}
        </div>
      </div>

      <div className="settings-field">
        <div className="settings-field__label">
          <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            <Icon source={CashDollarIcon} tone="base" />
            Store Currency
          </span>
        </div>
        <div className="settings-field__control" style={{ flexDirection: "column", alignItems: "flex-start" }}>
          <span className="app-chip app-chip--info">
            {storeData.currencyCode || "—"}
          </span>
          <Text as="p" tone="subdued">
            Product feed uses your Shopify default currency.{" "}
            {storeData.primaryDomain ? (
              <Link
                url={`${storeData.primaryDomain}/admin/settings/general`}
                target="_blank"
              >
                Change in Store settings
              </Link>
            ) : null}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default StoreDetails;
